export default "__VITE_ASSET__6ed7529c__"